export function generateDistinctColorOptimized(
    specifier: string,
    totalColors: number,
    active : boolean
  ): string {
    const charCode = specifier.toUpperCase().charCodeAt(0);
    if (charCode < 65 || charCode > 90) {
      throw new Error("Invalid specifier. Must be a letter from 'A' to 'Z'.");
    }
  
    const colorIndex = charCode - 65;
  
    // Distribute hues evenly across the color wheel based on the total number of colors
    const hue = (colorIndex / totalColors) * 360;
  
    // Maintain relatively high and consistent saturation and lightness for better distinction
    const saturation = active ? 0.95 : 0.25;
    const lightness = active ? 0.7 : 0.8;
  
    // Convert HSL to RGB
    const { r, g, b } = hslToRgb(hue, saturation, lightness);
  
    // Format as an RGB string
    return `rgb(${Math.round(r * 255)}, ${Math.round(g * 255)}, ${Math.round(b * 255)})`;
  }
  
  function hslToRgb(h: number, s: number, l: number): { r: number; g: number; b: number } {
    h /= 360;
  
    let r: number, g: number, b: number;
  
    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      const hue2rgb = (p: number, q: number, t: number): number => {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      };
  
      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
  
    return { r, g, b };
  }
  